import React, { useEffect, useState } from "react";

export default ({ user }) => {
  const [editMode, seteditMode] = useState(false);
  const [formData, setFormData] = useState({
    firstName: user.firstName,
    lastName: user.lastName,
    userName: user.userName || "",
    email: user.email,
    contactNumber: user.contactNumber || "",
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const [userData, setuserData] = useState({
    firstName: "",
    lastName: "",
  });
  useEffect(() => {}, []);
console.log(user)

const handleUpdate=()=>{
  console.log("i am clicked ",formData)



}

  return (
    <div>
      <div className="profile-info">
        <div
          className="top-part"
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "space-between",
          }}
        >
          Profile Info
          {/* {!editMode && (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => seteditMode(true)}
            >
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title />

                <g id="Complete">
                  <g id="edit">
                    <g>
                      <path
                        d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8"
                        fill="none"
                        stroke="#000000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />

                      <polygon
                        fill="none"
                        points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8"
                        stroke="#000000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          )} */}
        </div>
        {user && (
          <>
            <div className="info-details">
              <div className="name fw-bold">First Name:</div>
              <div
                className="e-name"
                style={{ marginBottom: `${editMode ? "10px" : "0px"}` }}
              >
                {editMode ? (
                  <input
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    onChange={handleInputChange}
                    type="text"
                    value={formData.firstName}
                    readOnly={!editMode}
                  />
                ) : (
                  <> {user.firtsName}</>
                )}
              </div>
            </div>
            <div className="info-details">
              <div className="name fw-bold">Last Name:</div>
              <div
                className="e-name"
                style={{ marginBottom: `${editMode ? "10px" : "0px"}` }}
              >
                {editMode ? (
                  <input
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    type="text"
                    value={user.lastName}
                    readOnly={!editMode}
                  />
                ) : (
                  <>{user.lastName}</>
                )}
              </div>
            </div>
            {user.userName && (
              <div className="info-details">
                <div className="name fw-bold">UserName:</div>
                <div
                  className="e-name"
                  style={{ marginBottom: `${editMode ? "10px" : "0px"}` }}
                >
                  {editMode ? (
                    <input
                      style={{
                        width: "100%",
                        height: "40px",
                      }}
                      type="text"
                      value={user.userName}
                      readOnly={!editMode}
                    />
                  ) : (
                    <> {user.userName}</>
                  )}
                </div>
              </div>
            )}
            <div className="info-details">
              <div className="name fw-bold">Email:</div>
              <div
                className="e-name"
                style={{ marginBottom: `${editMode ? "10px" : "0px"}` }}
              >
                {editMode ? (
                  <input
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    type="email"
                    value={user.email}
                    readOnly={!editMode}
                  />
                ) : (
                  <> {user.email}</>
                )}
              </div>
            </div>
            <div className="info-details">
              <div className="name fw-bold">Phone:</div>
              <div
                className="e-name"
                style={{ marginBottom: `${editMode ? "10px" : "0px"}` }}
              >
                {editMode ? (
                  <input
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    type="number"
                    value={user.contactNumber}
                    readOnly={!editMode}
                  />
                ) : (
                  <> {user.contactNumber}</>
                )}
              </div>
            </div>
          </>
        )}
        {editMode && (
          <>
             <button
              type="submit"
              style={{
                borderRadius: "2px",
                height: "48px",
                border: "none",
                width: "100%",
                display: "block",
                backgroundColor: "#619f32",
                color: "#fff",
                marginTop: "10px",
                marginBottom: "10px",
              }}
              onClick={handleUpdate}
              className="checkout-btn paynow"
            >
              UPDATE
            </button>

            <button
              type="submit"
              style={{
                borderRadius: "2px",
                height: "48px",
                border: "none",
                width: "100%",
                display: "block",
                backgroundColor: "#d73829",
                color: "#fff",
                marginTop: "10px",
                marginBottom: "10px",
              }}
              onClick={() => seteditMode(false)}
              className="checkout-btn paynow"
            >
              CANCEL
            </button>
          </>
        )}
      </div>
    </div>
  );
};
